import PropTypes from "prop-types";
import "./SectionTitle.scss";
import Icon from "core/icon/Icon";
import { ReactComponent as BookIcon } from "assets/icons/book.svg";
import { ReactComponent as CommentIcon } from "assets/icons/comment.svg";
import { ReactComponent as DashboardIcon } from "assets/icons/dashboard.svg";
import { ReactComponent as DavIcon } from "assets/icons/dav.svg";
import { ReactComponent as EventIcon } from "assets/icons/event.svg";
import { ReactComponent as ProjectIcon } from "assets/icons/project.svg";
import { ReactComponent as SalaryIcon } from "assets/icons/salary.svg";
import { ReactComponent as SolidavIcon } from "assets/icons/solidav.svg";
import { ReactComponent as StatsIcon } from "assets/icons/stats.svg";
import { ReactComponent as UserIcon } from "assets/icons/user.svg";
import { ReactComponent as WorkLifeBalanceIcon } from "assets/icons/workLifeBalance.svg";
import { marginForOtherIcons, marginForUserIcon } from "constants/constants";

const INLINE_SVG_ICONS = {
  book: BookIcon,
  comment: CommentIcon,
  dashboard: DashboardIcon,
  dav: DavIcon,
  event: EventIcon,
  project: ProjectIcon,
  salary: SalaryIcon,
  solidav: SolidavIcon,
  stats: StatsIcon,
  user: UserIcon,
  workLifeBalance: WorkLifeBalanceIcon,
};

const SectionTitle = ({ title, icon, isExport }) => {
  let parsedIcon = "";
  const structureObj = JSON.parse(icon);
  parsedIcon = structureObj.icon || "";
  const iconColor = parsedIcon ? "white" : "transparent";
  const iconClassName = parsedIcon === "user" ? "scale-class" : "";
  const iconMarginBottom =
    parsedIcon === "user" ? marginForUserIcon : marginForOtherIcons;
  const InlineIcon = isExport ? INLINE_SVG_ICONS[parsedIcon] : null;

  return (
    <div className="section-title">
      <div className="icon-wrapper">
        {InlineIcon ? (
          <span
            className="section-title-export-icon-wrapper"
            style={{ marginRight: 15, marginBottom: iconMarginBottom }}
          >
            <InlineIcon
              className={`section-title-export-icon ${iconClassName}`}
            />
          </span>
        ) : (
          <Icon
            color={iconColor}
            icon={parsedIcon}
            marginRight={15}
            marginBottom={iconMarginBottom}
            className={iconClassName}
          />
        )}
      </div>
      <div className="title">{title}</div>
    </div>
  );
};

SectionTitle.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string,
  isExport: PropTypes.bool,
};

SectionTitle.defaultProps = {
  title: "",
  icon: "personal",
  isExport: false,
};

export default SectionTitle;
